import { Box } from "@mui/system";
import React from "react";
import Banner from "./Banner/Banner";

const Contact = () => {
  return (
    <div>
      <Box sx={{ padding: "50px 60px" }}>
        <Banner />
      </Box>
    </div>
  );
};

export default Contact;
